<template>
  <div id="signup">
    <div class="container">
      <div class="form-group">
        <div class="form-container" :class="{ 'has-error': idHasError }">
          <label class="label" for="email">{{ idMessage }}</label>
          <input
            type="email"
            name=""
            id="email"
            placeholder="Type your email address"
            v-model.trim="userID"
            @input="
              idMessage = 'Email'
              idHasError = false
            "
          />
        </div>
        <div class="form-container" :class="{ 'has-error': pwHasError }">
          <label class="label" for="passward">{{ pwMessage }}</label>
          <input
            type="password"
            name=""
            id="password"
            placeholder="Type password"
            v-model.trim="userShadow"
            @input="
              pwMessage = 'Password'
              pwHasError = false
            "
          />
        </div>
        <div
          class="form-container for-agreement"
          :class="{ 'has-error': !isTermsAgree }"
        >
          <input
            type="checkbox"
            name="agreement"
            id="agreement"
            v-model="isTermsAgree"
            @change="
              (event) => {
                onTermsCheckClick(event.target.checked)
              }
            "
          />
          <label for="agreement">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="checked"
            >
              <polyline points="9 11 12 14 22 4"></polyline>
              <path
                d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
              ></path>
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="unchecked"
            >
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            </svg>
            <span>I have read and agree to the</span>
            <a @click="onTermsClick"> Terms & Conditions</a>
          </label>
        </div>
      </div>

      <div class="button-group">
        <div class="button-container">
          <div class="button" @click="goBack">Cancel</div>
        </div>
        <div class="button-container">
          <div class="button" @click="onSignUpClick">OK</div>
        </div>
      </div>

      <div class="social-group">
        <div class="social apple" @click="performSocialSignUp('Apple')">
          Sign in with Apple ID
        </div>
        <div class="social facebook" @click="performSocialSignUp('Facebook')">
          Sign in with Facebook
        </div>
        <div class="social google" @click="performSocialSignUp('Google')">
          Sign in with Google
        </div>
      </div>
    </div>

    <div class="modal" v-if="isShowDialog">
      <div class="modal-contents">
        <div class="modal-header">Done!</div>
        <div class="modal-body">
          You are almost ready! Please check your mailbox to verify your email
          address.
        </div>
        <div class="modal-footer">
          <div class="button-group">
            <div class="button" @click="onSignUpDoneClick">OK</div>
          </div>
        </div>
      </div>
    </div>

    <comp-loading v-if="isLoading" :fullscreen="true"></comp-loading>
  </div>
</template>

<script>
import common from '@/utils/common'
import CompLoading from '@/components/CompLoading.vue'

export default {
  name: 'Signup',
  mixins: [common],
  components: {
    CompLoading
  },
  data() {
    return {
      pageTitle: 'Sign Up',

      isLoading: false,
      isShowDialog: false,

      idHasError: false,
      pwHasError: false,

      idMessage: 'Email',
      pwMessage: 'Password',

      userID: localStorage.getItem('tempID'),
      userShadow: localStorage.getItem('tempPW'),

      isTermsAgree: localStorage.getItem('tempTermsAgree') === 'true'
    }
  },
  created() {
    this.$parent.setNav(false)
    this.$parent.setHeader(this.pageTitle)
    this.$parent.headerBack = true
    this.$parent.setBottomTab(false)
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile
    }
  },
  methods: {
    saveTempInputDatas() {
      if (!this.isEmpty(this.userID)) {
        localStorage.setItem('tempID', this.userID)
      }
      if (!this.isEmpty(this.userShadow)) {
        localStorage.setItem('tempPW', this.userShadow)
      }
      if (this.isTermsAgree != null) {
        localStorage.setItem('tempTermsAgree', this.isTermsAgree)
      }
    },
    onTermsCheckClick(isChecked) {
      this.isTermsAgree = isChecked
    },
    onTermsClick() {
      this.saveTempInputDatas()
      this.goPageWithParams('TermsConditions', { isSignUp: true })
    },
    onSignUpClick() {
      var errorFlag = false

      if (this.isEmpty(this.userID)) {
        this.idHasError = true
        this.idMessage = 'Please check this area.'
        errorFlag = true
      } else {
        this.idMessage = 'Email'
        this.idHasError = false
      }
      if (this.isEmpty(this.userShadow)) {
        this.pwHasError = true
        this.pwMessage = 'Please check this area.'
        errorFlag = true
      } else {
        this.pwMessage = 'Password'
        this.pwHasError = false
      }

      if (errorFlag || !this.isTermsAgree) return
      this.isLoading = true

      const user = {
        userId: this.userID,
        password: this.userShadow
      }
      this.$store.dispatch('auth/register', user).then((data) => {
        this.isLoading = false

        if (data.resultCode === 0) {
          this.isShowDialog = true
        } else {
          this.idMessage = data.resultMsg
          this.idHasError = true
        }
      })
    },
    onSignUpDoneClick() {
      this.goPageWithParams('Signin', { signUp: true })
    },
    performSocialSignUp(socialType) {
      this.$router.replace({
        name: 'Signin',
        params: { signUpSocial: socialType }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="@/scss/acc.scss" scoped></style>
